const startEndChar = '|';

export const formatEiqPassportCode = (code: string) => {
  return `${startEndChar}${code}${startEndChar}`;
};
